import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../constants';
import * as D from '../../deps';

import './ArtistRadioOnlyModal.scss';

export const ArtistRadioOnlyModal: React.FC = () => {
  return (
    <div className='ArtistRadioOnlyModal'>
      <FormattedMessage {...D.Constants.Catalog.messages.radioOnlyPlaylist} />
    </div>
  );
};

interface IArtistRadioOnlyModalButtonProps {
  onModalStartStationClick: $TSFixMeFunction;
}

export const ArtistRadioOnlyModalButton: React.FC<IArtistRadioOnlyModalButtonProps> = props => {
  const { onModalStartStationClick } = props;
  return (
    <D.ButtonT3 size={D.ButtonT3Size.SMALL} onClick={onModalStartStationClick}>
      <FormattedMessage {...BackstageConstants.messages.startStation} />
    </D.ButtonT3>
  );
};

interface IgetRadioOnlyModalConfigProps {
  hasRadio?: boolean;
  onModalStartStationClick: $TSFixMeFunction;
}

export const getRadioOnlyModalConfig = (props: IgetRadioOnlyModalConfigProps): $TSFixMe => {
  const { hasRadio, onModalStartStationClick } = props;
  return {
    modalType: 'ModalCoachMark',
    title: '',
    body: <ArtistRadioOnlyModal />,
    buttons: hasRadio
      ? [<ArtistRadioOnlyModalButton key={0} onModalStartStationClick={onModalStartStationClick} />]
      : null,
  };
};
